import React from "react";
import ReactDOM from "react-dom/client";
import "./style.css";
import App from "./App";
import { HashRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HashRouter hashtype="hashbang">
      <App />
    </HashRouter>
  </React.StrictMode>
);
